import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireModule } from '../../../app/guards'

/** Payroll (ADR-048): an opt-in module over Human resources; every page below needs both. */
export const Route = createFileRoute('/_app/payroll')({
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'hr')
    requireModule(context.session, 'payroll')
  },
  component: Outlet,
})
